import React from 'react';
import { Link } from 'react-router-dom';
import SortableHeader from '../../components/SortableHeader';
import { Plus } from 'lucide-react';
import { fmtCurrency } from '../../utils/formatCurrency';

function AccountOpportunitiesTab({
  accountId,
  sortedOpportunities,
  opportunitiesSort,
  handleOpportunitiesSort,
  canDo,
  setShowOpportunityModal,
}) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Opportunities</h3>
        {canDo('opportunities', 'create') && (
          <button className="btn btn-primary btn-sm" onClick={() => setShowOpportunityModal(true)}>
            <Plus size={16} />
            New Opportunity
          </button>
        )}
      </div>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <SortableHeader label="Name" field="name" sortField={opportunitiesSort.field} sortDirection={opportunitiesSort.direction} onSort={handleOpportunitiesSort} />
              <SortableHeader label="Stage" field="stage_name" sortField={opportunitiesSort.field} sortDirection={opportunitiesSort.direction} onSort={handleOpportunitiesSort} />
              <SortableHeader label="Amount" field="amount" sortField={opportunitiesSort.field} sortDirection={opportunitiesSort.direction} onSort={handleOpportunitiesSort} />
              <SortableHeader label="Expected Close" field="expected_close_date" sortField={opportunitiesSort.field} sortDirection={opportunitiesSort.direction} onSort={handleOpportunitiesSort} />
              <SortableHeader label="Owner" field="owner_name" sortField={opportunitiesSort.field} sortDirection={opportunitiesSort.direction} onSort={handleOpportunitiesSort} />
              <SortableHeader label="Contact" field="contact_name" sortField={opportunitiesSort.field} sortDirection={opportunitiesSort.direction} onSort={handleOpportunitiesSort} />
            </tr>
          </thead>
          <tbody>
            {sortedOpportunities.length > 0 ? (
              sortedOpportunities.map(opp => (
                <tr key={opp.id}>
                  <td>
                    <Link to={`/opportunities/${opp.id}`} state={{ fromAccount: accountId }}>{opp.name}</Link>
                  </td>
                  <td>
                    <span className={`badge ${opp.is_won ? 'badge-success' : opp.is_lost ? 'badge-danger' : 'badge-primary'}`}>
                      {opp.stage_name || 'No Stage'}
                    </span>
                  </td>
                  <td>${fmtCurrency(opp.amount)}</td>
                  <td>
                    {opp.expected_close_date
                      ? new Date(opp.expected_close_date).toLocaleDateString()
                      : '-'}
                  </td>
                  <td>{opp.owner_name || '-'}</td>
                  <td>{opp.contact_name || '-'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center text-secondary">No opportunities</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AccountOpportunitiesTab;
